export class ReportChangeLogFilter {
    integrationId?: string;
    clientId?: number;

    minChangeDate?: Date;
    maxChangeDate?: Date;
}
